export const trimToNull = (str?: string): string | null => {
  if (!str) return null

  const trimmed = str.trim()
  return trimmed.length > 0 ? trimmed : null
}

// Segment translations embed digit-tagged markup like `<0>2</0>` for the m² superscript. Plain-text fields can't render <sup>, so we substitute the unicode superscript glyph instead.
const SUPERSCRIPT_DIGITS = '⁰¹²³⁴⁵⁶⁷⁸⁹'
export const stripSegmentMarkup = (raw: string): string =>
  raw.replace(/<\d+>(\d+)<\/\d+>/g, (_, digits: string) =>
    digits.replace(/\d/g, d => SUPERSCRIPT_DIGITS[Number(d)])
  )

